<app-sistema-menu></app-sistema-menu>
<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0em;">
        <div style="background: #FFF; border-radius: 0em; ">
            <section class="hero is-primary">
                <div class="level-left">
                    <div class="level-item">
                        <p class="title">
                            <span class="icon is-medium">
                            </span>
                            <span class="icon is-medium" style="margin-top: 0.4em;">
                                <i class="icon-analytics2"></i>
                            </span>
                            <span class="icon is-medium">
                                <i class="fa"></i>
                            </span> Dashboard Escolar
                        </p>
                    </div>
                </div>
            </section>

            <section class="section" style="overflow: auto;padding: 1rem !important;height: 87.3vh;">
                <!-- <div class="tile is-ancestor">
                    <div class="tile is-parent">
                      <article class="tile is-child box">
                        <p class="title">Hello World</p>
                        <p class="subtitle">What is up?</p>
                      </article>
                    </div>

                    <div class="tile is-parent">
                        <article class="tile is-child box">
                          <p class="title">Foo</p>
                          <p class="subtitle">Bar</p>
                        </article>
                      </div>
                      <div class="tile is-parent">
                        <article class="tile is-child box">
                          <p class="title">Third column</p>
                          <p class="subtitle">With some content</p>
                          <div class="content">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.</p>
                          </div>
                        </article>
                      </div>
                </div> -->

                <div class="tile is-ancestor">
                    <div class="tile is-vertical is-12">
                        <div class="tile">
                            <div class="tile is-parent is-vertical">
                                <article class="tile is-child box">
                                    <p class="title">Alumnos Inscritos</p>
                                    <!-- <p class="subtitle">Top box</p> -->

                                    <div class="tile is-ancestor">
                                        <div class="tile is-parent">
                                            <article class="tile is-child box">
                                                <p class="title">Mujeres</p>
                                                <!-- <p class="subtitle">Subtitle</p> -->
                                                <div class="content">
                                                    <p><i class="fa fa-female fa-2x"></i> 275</p>
                                                </div>

                                            </article>
                                        </div>

                                        <div class="tile is-parent">
                                            <article class="tile is-child box">
                                                <p class="title">Hombres</p>
                                                <!-- <p class="subtitle">Subtitle</p> -->
                                                <div class="content">
                                                    <p><i class="fa fa-male"></i> 275</p>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                </article>
                                <article class="tile is-child box">
                                    <p class="title">Vertical tiles</p>
                                    <p class="subtitle">Bottom box</p>
                                </article>
                            </div>
                            <div class="tile is-parent">
                                <article class="tile is-child box">
                                    <p class="title">Middle box</p>
                                    <p class="subtitle">With an image</p>
                                    <figure class="image is-4by3">
                                        <img src="https://bulma.io/images/placeholders/640x480.png">
                                    </figure>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>